import React from 'react';
import { Link } from 'react-router';

const SlimFooter = (props) => (
  <footer className="footer-minimal">
    <div className='footer-bottom-wrapper'>
      <div className="">
        <span>Copyright &copy; {props.currentYear} ShippingCart.</span>
      </div>
      <div className='footer-bottom-link-wrapper'>
        <div className='footer-bottom-link'>
          <Link to="/terms-conditions">Terms and Conditions</Link>
        </div>
        <div>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </div>
    </div>
  	</footer>
);

export default SlimFooter;


/** WEBPACK FOOTER **
 ** ./src/components/Layout/Footer/SlimFooter.js
 **/